import { ColdWaterIcon, EnergyIcon, HeatingIcon, HotWaterIcon } from 'assets/icons';
import { ServiceUnit, TricServiceCode } from 'common/model/meterReadings/tricModels';
import { SvgIconComponent } from '../model/type';
import { TariffToIcon } from '../model/meter';
import { ReactNode } from 'react';

interface ServiceUnitWithIcon extends ServiceUnit {
    icon: SvgIconComponent;
}

type TricServiceUnitsType = {
    [key in TricServiceCode]:
    | ServiceUnitWithIcon
    | ServiceUnitWithIcon[];
} & {
    [TricServiceCode.HEATING]: ServiceUnitWithIcon[];
};

export const TricServiceUnits: TricServiceUnitsType = {
    [TricServiceCode.COLD_WATER_10]: {
        unit: 'м³',
        maxConsumption: 80,
        icon: ColdWaterIcon,
    },
    [TricServiceCode.COLD_WATER_55]: {
        unit: 'м³',
        maxConsumption: 80,
        icon: ColdWaterIcon,
    },
    [TricServiceCode.COLD_WATER_72]: {
        unit: 'м³',
        maxConsumption: 80,
        icon: ColdWaterIcon,
    },
    [TricServiceCode.COLD_WATER_703]: {
        unit: 'м³',
        maxConsumption: 80,
        icon: ColdWaterIcon,
    },

    [TricServiceCode.HOT_WATER_8]: {
        unit: 'м³',
        maxConsumption: 80,
        icon: HotWaterIcon,
    },
    [TricServiceCode.HOT_WATER_249]: {
        unit: 'м³',
        maxConsumption: 80,
        icon: HotWaterIcon,
    },

    [TricServiceCode.ELECTRICITY]: {
        unit: 'кВт.ч',
        maxConsumption: 6000,
        icon: EnergyIcon,
    },

    [TricServiceCode.HEATING]: [
        { unit: 'Гкалл', maxConsumption: 12, icon: HeatingIcon },
        { unit: 'МВт', maxConsumption: 14, icon: HeatingIcon },
        { unit: 'кВт', maxConsumption: 14000, icon: HeatingIcon },
        { unit: 'ГДж', maxConsumption: 50, icon: HeatingIcon }
    ]
};


export const getTricServiceIcon = (code: TricServiceCode): SvgIconComponent => {
    const serviceData = TricServiceUnits[code];

    if (Array.isArray(serviceData)) {
        return serviceData[0].icon;
    }

    return serviceData.icon;
};


export const getIconByTheTricServiceName = (serviceName: string): React.FC => {
    let selectedTariff = '';
    Object.keys(TariffToIcon).forEach(tarif => {
        if (serviceName.toLowerCase().includes(tarif.toLowerCase())) {
            selectedTariff = tarif;
        }
    });
    const SelectedIcon = TariffToIcon[selectedTariff];

    return SelectedIcon ?? (() => '');
};
